import { memo } from 'react'
import { cva, VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const CardLayoutBox = memo(
  ({
    ref,
    ...props
  }: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>> & {
    ref?: React.RefObject<HTMLDivElement>
  }) => {
    const { className, ...rest } = props
    return (
      <div className={cn(`grid grid-cols-2`, className)} ref={ref} {...rest}>
        {props.children}
      </div>
    )
  }
)

CardLayoutBox.displayName = `CardLayoutBox`

const cardBoxVariants = cva(`w-full`, {
  variants: {
    variant: {
      left: `pr-8`,
      center: ``,
      right: `pl-8 border-l border-gray-200`
    }
  },
  defaultVariants: {
    variant: `center`
  }
})

type CardBoxProps = VariantProps<typeof cardBoxVariants> & React.HTMLAttributes<HTMLDivElement>

const CardBox = memo(
  ({
    ref,
    ...props
  }: React.PropsWithChildren<CardBoxProps> & {
    ref?: React.RefObject<HTMLDivElement>
  }) => {
    const { className, variant, ...rest } = props
    return (
      <div className={cn(cardBoxVariants({ variant }), className)} ref={ref} {...rest}>
        {props.children}
      </div>
    )
  }
)

CardBox.displayName = `CardBox`

export { CardLayoutBox, CardBox }
